module.exports = __webpack_public_path__ + "static/media/facility_click-through_rates_CTR.6c55a5e5.png";